// extracted by mini-css-extract-plugin
export default {"link":"JobButton_link__faKI-","container":"JobButton_container__YIjzY","text":"JobButton_text__yh4OC","arrow":"JobButton_arrow__kwxvQ"};